import * as React from 'react';
import { useMobileDetection } from 'framework/utils/useMobileDetection';

interface MobileNavContextType {
  isMobile: boolean;
  isMobileNavOpen: boolean;
  toggleMobileNav: () => void;
  closeMobileNav: () => void;
}

const MobileNavContext = React.createContext<MobileNavContextType | undefined>(undefined);

export const MobileNavProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = React.useState(false);
  const isMobile = useMobileDetection();

  const toggleMobileNav = React.useCallback(() => {
    setIsMobileNavOpen((prev) => !prev);
  }, []);

  const closeMobileNav = React.useCallback(() => {
    setIsMobileNavOpen(false);
  }, []);

  const value = React.useMemo(
    () => ({
      isMobile,
      isMobileNavOpen,
      toggleMobileNav,
      closeMobileNav,
    }),
    [isMobile, isMobileNavOpen, toggleMobileNav, closeMobileNav]
  );

  return <MobileNavContext.Provider value={value}>{children}</MobileNavContext.Provider>;
};

export const useMobileNav = () => {
  const context = React.useContext(MobileNavContext);
  if (context === undefined) {
    throw new Error('useMobileNav must be used within a MobileNavProvider');
  }
  return context;
};
